enum LoaderErrors {
    OK = 'OK',
    EXCEPTION = 'EXCEPTION',
    HTTP_STATUS_CODE_INVALID = 'HTTP_STATUS_CODE_INVALID',
    CONNECTING_TIMEOUT = 'CONNECTING_TIMEOUT',
    EARLY_EOF = 'EARLY_EOF',
    UNRECOVERABLE_EARLY_EOF = 'UNRECOVERABLE_EARLY_EOF',
    PARSE_PLAYLISTING_ERROR = 'PARSE_PLAYLISTING_ERROR'
}
export default LoaderErrors;
